export enum HourBookingCategory {
    Normal = 0,
    PeriodOvertime50 = 1,
    PeriodOvertime100 = 2,
    WeekOvertime50 = 3,
    WeekOvertime100 = 4,
    Evening = 5,
    Night = 6,
    Saturday = 7,
    SundayOrHoliday = 8,
    PaidBreak = 10,
    CustomNormalType = 11,
    GrandHoliday = 13,
    HalfDailyAllowance = 21,
    DailyAllowance = 22,
    IncreasedDailyAllowance = 23,
    ForeignDailyAllowance = 24,
    DailyOvertime50 = 33,
    DailyOvertime100 = 34,
    MonthlyOvertime50 = 35,
    SundayOrHolidayEvening = 42,
    SundayOrHolidayNight = 43,
    OvertimeBase = 50,
    Break = 100,
    PaidWaiting = 101,
    UnPaidWaiting = 102,
    CustomAnyType = 110, // Custom category for anything other than normal work.
    CustomAddition = 111,
    FixedAddition = 120,
    VehicleGroupAddition = 130,
    OvernightStay = 200,
    MealBreak = 1001,
    PaidMealBreak = 1002,
    OverTimeCalculation = 2000,
    DayBookingNormal = 2001,
    DayBookingOther = 2002,
    FillingHourCalculation = 3000,
    FillingHour = 3001,
}

export const normalWorkPaidCategories = () =>
    [
        HourBookingCategory.Normal,
        HourBookingCategory.PaidBreak,
        HourBookingCategory.PaidWaiting,
        HourBookingCategory.FillingHour,
    ].map((c) => c.toString());

// Additions
export const additionCategories = () =>
    [
        HourBookingCategory.Evening,
        HourBookingCategory.Night,
        HourBookingCategory.Saturday,
        HourBookingCategory.SundayOrHoliday,
        HourBookingCategory.SundayOrHolidayEvening,
        HourBookingCategory.SundayOrHolidayNight,
        HourBookingCategory.GrandHoliday,
        HourBookingCategory.CustomAddition,
        HourBookingCategory.FixedAddition,
        HourBookingCategory.VehicleGroupAddition,
    ].map((c) => c.toString());

// Overtime
export const overtimeCategories = () =>
    [
        HourBookingCategory.PeriodOvertime50,
        HourBookingCategory.PeriodOvertime100,
        HourBookingCategory.WeekOvertime50,
        HourBookingCategory.WeekOvertime100,
        HourBookingCategory.DailyOvertime50,
        HourBookingCategory.DailyOvertime100,
        HourBookingCategory.MonthlyOvertime50,
    ].map((c) => c.toString());

export const paidHourBookingCategories = () =>
    [
        HourBookingCategory.Normal,
        HourBookingCategory.CustomNormalType,
        HourBookingCategory.PaidBreak,
        HourBookingCategory.PaidWaiting,
        HourBookingCategory.DayBookingNormal,
        HourBookingCategory.OvertimeBase,
        HourBookingCategory.FillingHour,
    ].map((c) => c.toString());

export const deductionHourBookingCategories = () =>
    [
        HourBookingCategory.Break,
        HourBookingCategory.UnPaidWaiting,
        HourBookingCategory.MealBreak,
    ].map((c) => c.toString());

export const dailyAllowanceCategories = () =>
    [
        HourBookingCategory.HalfDailyAllowance,
        HourBookingCategory.DailyAllowance,
        HourBookingCategory.IncreasedDailyAllowance,
        HourBookingCategory.ForeignDailyAllowance,
    ].map((c) => c.toString());

export const deletableCategories = () =>
    [
        HourBookingCategory.Evening,
        HourBookingCategory.Night,
        HourBookingCategory.Saturday,
        HourBookingCategory.SundayOrHoliday,
        HourBookingCategory.SundayOrHolidayEvening,
        HourBookingCategory.SundayOrHolidayNight,
        HourBookingCategory.PaidBreak,
        HourBookingCategory.GrandHoliday,
        HourBookingCategory.HalfDailyAllowance,
        HourBookingCategory.DailyAllowance,
        HourBookingCategory.IncreasedDailyAllowance,
        HourBookingCategory.ForeignDailyAllowance,
        HourBookingCategory.PaidWaiting,
        HourBookingCategory.MealBreak,
        HourBookingCategory.PaidMealBreak,
        HourBookingCategory.OverTimeCalculation,
        HourBookingCategory.FillingHourCalculation,
        HourBookingCategory.FixedAddition,
    ].map((c) => c.toString());

export const fillingHourCategories = () =>
    [
        HourBookingCategory.FillingHour,
    ].map((c) => c.toString());

export const daybookingFillingHourCategories = () =>
    [
        HourBookingCategory.DayBookingOther,
    ].map((c) => c.toString());

export const salaryRowTypeSelectableCategories = () =>
    [
        HourBookingCategory.Normal,
        HourBookingCategory.PeriodOvertime50,
        HourBookingCategory.PeriodOvertime100,
        HourBookingCategory.WeekOvertime50,
        HourBookingCategory.WeekOvertime100,
        HourBookingCategory.Evening,
        HourBookingCategory.Night,
        HourBookingCategory.Saturday,
        HourBookingCategory.SundayOrHoliday,
        HourBookingCategory.PaidBreak,
        HourBookingCategory.CustomNormalType,
        HourBookingCategory.GrandHoliday,
        HourBookingCategory.HalfDailyAllowance,
        HourBookingCategory.DailyAllowance,
        HourBookingCategory.IncreasedDailyAllowance,
        HourBookingCategory.ForeignDailyAllowance,
        HourBookingCategory.DailyOvertime50,
        HourBookingCategory.DailyOvertime100,
        HourBookingCategory.MonthlyOvertime50,
        HourBookingCategory.SundayOrHolidayEvening,
        HourBookingCategory.SundayOrHolidayNight,
        HourBookingCategory.OvertimeBase,
        HourBookingCategory.Break,
        HourBookingCategory.PaidWaiting,
        HourBookingCategory.UnPaidWaiting,
        HourBookingCategory.CustomAnyType,
        HourBookingCategory.CustomAddition,
        HourBookingCategory.FixedAddition,
        HourBookingCategory.MealBreak,
        HourBookingCategory.FillingHour,
    ].map((c) => c.toString());

export const workTimeReportSelectableUnpaidCategories = () =>
    [
        HourBookingCategory.Break,
        HourBookingCategory.UnPaidWaiting,
        HourBookingCategory.OvernightStay,
        HourBookingCategory.MealBreak,
    ].map((c) => c.toString());

export const workTimeReportSelectablePaidCategories = () =>
    [
        HourBookingCategory.PaidBreak,
        HourBookingCategory.OvertimeBase,
        HourBookingCategory.PaidWaiting,
    ].map((c) => c.toString());

export const workTimeReportSelectableOtherCategories = () =>
    [
        HourBookingCategory.PaidMealBreak,
        HourBookingCategory.OverTimeCalculation,
        HourBookingCategory.DayBookingNormal,
        HourBookingCategory.FillingHourCalculation,
    ].map((c) => c.toString());